var responsiveNav = require('./responsive-nav.js');

var customToggle = null;
var navigation = null;

document.addEventListener("DOMContentLoaded", function (event) {
  customToggle = document.getElementById('nav-toggle');
  navigation = responsiveNav('.nav-collapse', {
    customToggle: '#nav-toggle',
    enableFocus: true,
    enableDropdown: true,
    openDropdown: '<span class="screen-reader-text">Open sub menu</span>',
    closeDropdown: '<span class="screen-reader-text">Close sub menu</span>',
    resizeMobile: function () {
      customToggle.setAttribute('aria-controls', 'nav');
    },
    resizeDesktop: function () {
      customToggle.removeAttribute('aria-controls');
    },
  });
});
